import { useState } from 'react';

import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Button } from 'components/button';
import { isMobile, handleMutation } from 'hooks';
import { usePrintReceiptMutation } from 'store/api/clover';

import { SelectDeviceDialog } from './select-device-dialog';
import { PrintReceiptFromTerminalButtonProps } from './types';

export const PrintReceiptFromTerminalButton = ({
  pdfUrl,
  deviceId,
  buttonProps,
  deviceOptions,
  ...props
}: PrintReceiptFromTerminalButtonProps) => {
  const mobile = isMobile();
  const [isOpen, setOpen] = useState(false);
  const [printReceipt, mutation] = usePrintReceiptMutation();
  handleMutation({
    ...mutation,
    successMessage: `Receipt terminal print successful`,
  });

  const hasCloverDevices = deviceOptions && deviceOptions.length > 0;
  const isMultiCloverDevices = hasCloverDevices && deviceOptions.length > 1;

  const onClick = () => {
    if (!hasCloverDevices) {
      window.open(pdfUrl, '_blank');
      return;
    }

    if (deviceId && !isMultiCloverDevices) {
      printReceipt({ ...props, deviceId: deviceId! });
      return;
    }

    setOpen(true);
  };

  return (
    <>
      <Button
        text="Print"
        onClick={onClick}
        fullWidth={mobile}
        icon={<Icon.Printer />}
        disabled={mutation.isLoading}
        colorType={ButtonColors.LightBlue}
        {...buttonProps}
      />

      {hasCloverDevices && (
        <SelectDeviceDialog
          open={isOpen}
          deviceOptions={deviceOptions}
          onClose={() => setOpen(false)}
          onSubmit={async (values, close) => {
            try {
              const response = await printReceipt({
                ...props,
                deviceId: Number(values.deviceId),
              });

              if (!response.error) {
                close();
              }
            } catch (error) {
              console.error(error);
            }
          }}
        />
      )}
    </>
  );
};
